import { render, staticRenderFns } from "./Tab_Point_Detail.vue?vue&type=template&id=3e544013&scoped=true"
import script from "./Tab_Point_Detail.vue?vue&type=script&lang=js"
export * from "./Tab_Point_Detail.vue?vue&type=script&lang=js"
import style0 from "./Tab_Point_Detail.vue?vue&type=style&index=0&id=3e544013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e544013",
  null
  
)

export default component.exports